import { Container } from '@material-ui/core';
import styled from 'styled-components';

export const MainContainer = styled(Container)`
  display: flex;
  justify-content: center;
  padding-top: 30vh;
  padding-bottom: 30vh;
`;
